import type { TableColumn } from '@shared/components/data-table/data-table.component';

/**
 * Builds default table columns for warehouse list screens from shared config.
 */
export function buildWarehouseDefaultColumns(
  allColumns: TableColumn[],
  defaultOrder: readonly string[],
  actionsProp: string,
  includeActions: boolean,
): TableColumn[] {
  const fromConfig = (prop: string) =>
    allColumns.find((c) => c.prop === prop);

  const cols: TableColumn[] = [];
  for (const key of defaultOrder) {
    const col = fromConfig(key);
    if (col) cols.push(col);
  }
  if (includeActions) {
    const actionsCol = fromConfig(actionsProp);
    if (actionsCol) cols.push(actionsCol);
  }
  return cols;
}

/**
 * Builds flexible column list for warehouse advanced table.
 */
export function buildWarehouseFlexibleColumns(
  allColumns: TableColumn[],
  flexibleOrder: readonly string[],
): TableColumn[] {
  const fromConfig = (prop: string) =>
    allColumns.find((c) => c.prop === prop);

  const cols: TableColumn[] = [];
  for (const prop of flexibleOrder) {
    const col = fromConfig(prop);
    if (col) cols.push(col);
  }
  return cols;
}
